import $ from "jquery";

var global = true;

// console.log('window.asdaslocation.host', window.location.host);
var pathname = window.location.pathname.split('/');
// console.log('pathnamadase[1]', pathname[1]);
if(pathname[1] != 'gl') {
  $('.country-selector').val('gl');
} else {
  $('.country-selector').val(pathname[1]);
}

$('.country-selector option').each(function(index){
  // console.log($(this).attr('value'));
  var pathname = window.location.pathname.split('/');
  var value = $(this).attr('value').split('/');
  // console.log('pathname', pathname[1]);
  // console.log('value', value[1]);
  if(value[1] == pathname[1]) {
    $(this).attr('selected','selected');
    $('.country-flags .flag').eq(index).addClass('active');
    global = false;
  } 
});

if(global) {
  $('.country-selector option').first().attr('selected','selected');
  $('.country-flags .flag').eq(0).addClass('active');
}

$('.country-selector').on('change', function(){
  // console.log(this.value);
  // window.location = this.value; 
  location.replace('https://' + this.value);
});